import { render, staticRenderFns } from "./BancaEmaticaOperatoriView.vue?vue&type=template&id=378a12c9"
import script from "./BancaEmaticaOperatoriView.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaOperatoriView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports